import { Link, useLocation } from "#src/components/Router.tsx";
import { useStore } from "#src/stores/Store.tsx";
import { StripeType } from "#types/code-generator.ts";

export function AdyenActionBanner() {
  const store = useStore();
  const location = useLocation();
  const isBankPage = location.pathname === "/admin/bank";
  const showAdyenBanner =
    store.organization.paymentDisplay === StripeType.Adyen &&
    store.organization.stripe !== StripeType.Adyen &&
    store.organization.balanceAccounts.length === 0;

  if (!showAdyenBanner) {
    return null;
  }

  return (
    <Link
      to="/admin/bank"
      className="bg-paleError text-dark mb-4 block rounded-lg px-6 py-4 pb-2"
    >
      <div className="mb-4 flex items-center gap-2">
        <div className="bg-error flex h-12 w-12 items-center justify-center rounded-full">
          <i className="far fa-triangle-exclamation text-xl text-white" />
        </div>
        <div className="flex-1 font-bold">Immediate action required</div>
      </div>

      <p>
        In our commitment to growth and enhancements, Captyn has migrated to a
        new payment processor.
      </p>

      <p>
        The deadline to update your bank has passed. Old financial report
        screens are no longer available, and major updates are currently hidden
        from you. Newly added payment methods will not be stored until you add
        your bank.
      </p>

      {!isBankPage && (
        <p>
          <strong>
            Please <span className="text-organization">click here</span> choose
            + Add a bank and complete the process ASAP.
          </strong>
        </p>
      )}

      {isBankPage && (
        <p>
          <strong>
            Please choose + Add a bank above and complete the process ASAP.
          </strong>
        </p>
      )}
    </Link>
  );
}
